import { DB } from '_c/typings/model/db';
import { defineComponent, PropType } from 'vue';
import KkImage from '@/component/kk-image/kk-image.vue';

/** 文本链接解析内容 */
export default defineComponent({
  name: 'VideoLinkContent',
  components: {
    KkImage,
  },
  props: {
    linkMsgInfo: {
      type: Object as PropType<DB.ILinkMsgInfo>,
      default: () => null,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    thumbnail(): string {
      const { thumbnail, videoInfo } = this.linkMsgInfo;
      return thumbnail || videoInfo?.picUrl || '';
    },
  },
  methods: {
    onClickHandler() {
      const link = this.linkMsgInfo?.link;
      if (link) window.open(link);
    },
  },
});
